import { useEffect, useRef } from 'react';
import './AnimatedSnowflakes.css';

const SNOWFLAKE_COUNT = 30;

const getRandom = (min, max) => Math.random() * (max - min) + min;

const AnimatedSnowImage = () => {
  const flakesRef = useRef([]);

  useEffect(() => {
    function animate(states, running) {
      try {
        const now = Date.now();
        flakesRef.current.forEach((flake, i) => {
          if (!flake) return;
          const state = states[i];
          if (!state) return;
          const elapsed = now - state.start;
          const progress = Math.min(elapsed / state.duration, 1);
          // Animate rotation and scale down
          const angle = state.angle + progress * 360 * state.speed;
          const scale = 1 - progress;
          const opacity = 1 - progress;
          flake.style.transform = `rotate(${angle}deg) scale(${scale})`;
          flake.style.opacity = opacity;
          // When finished, reset to new random state
          if (progress >= 1) {
            states[i] = {
              angle: getRandom(0, 360),
              scale: 1,
              opacity: 1,
              speed: getRandom(0.5, 1.2),
              duration: getRandom(1200, 2200),
              start: now,
              left: getRandom(0, 100),
              top: getRandom(0, 100),
              size: getRandom(18, 32)
            };
            flake.style.left = `${states[i].left}vw`;
            flake.style.top = `${states[i].top}vh`;
            flake.style.width = `${states[i].size}px`;
            flake.style.height = 'auto';
          }
        });
        if (running.value)
          requestAnimationFrame(() => animate(states, running));
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('AnimatedSnowImage animate error:', err);
      }
    }
    try {
      // Each flake gets its own animation state
      const states = Array.from({ length: SNOWFLAKE_COUNT }).map(() => ({
        angle: getRandom(0, 360),
        scale: 1,
        opacity: 1,
        speed: getRandom(0.5, 1.2),
        duration: getRandom(1200, 2200),
        start: Date.now(),
        left: getRandom(0, 100),
        top: getRandom(0, 100),
        size: getRandom(18, 32)
      }));

      const running = { value: true };
      animate(states, running);
      return () => {
        running.value = false;
      };
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('AnimatedSnowImage useEffect error:', err);
    }
  }, []);

  return (
    <div className='animated-snowflakes-bg'>
      {Array.from({ length: SNOWFLAKE_COUNT }).map((_, i) => (
        <img
          key={i}
          ref={el => (flakesRef.current[i] = el)}
          src='/assets/snow.png'
          alt='snowflake'
          className='animated-snowflake-img'
          style={{
            left: `${getRandom(0, 100)}vw`,
            top: `${getRandom(0, 100)}vh`,
            opacity: 1,
            position: 'absolute',
            width: `${getRandom(18, 32)}px`,
            height: 'auto',
            pointerEvents: 'none',
            zIndex: 0
          }}
        />
      ))}
    </div>
  );
};

export default AnimatedSnowImage;
